import Component from "@base/js/component";
import breakpoint from "@base/js/util/breakpoint";
import GlobalService from "@services/global-service";

export default class InlineSearchBlock extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".inline-search-block";

  // Defines children that needs to be queried as part of this component
  static children = {
    cta: ".inline-search-block__cta",
  };

  isOpen = false;

  primaryNav = null;

  // Defines event handlers to attach to children
  eventHandlers = {
    cta: {
      click: this.onCTAClick,
    },
  };

  onCTAClick(e) {
    e.preventDefault();

    this.isOpen = true;
    GlobalService.toggleSearchOverlay();

    if (breakpoint() !== "desktop") {
      this.primaryNav.style.top = 0;
    }
  }

  afterInit() {
    if (breakpoint() === "desktop") return;

    this.primaryNav = document.querySelector(".primary-nav");
    const closeButton = this.primaryNav.querySelector(".primary-nav__search");

    closeButton.addEventListener("click", () => {
      if (!this.isOpen) return;

      this.primaryNav.style.top = "";
    });
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
InlineSearchBlock.init();
